import EthosGraphQLReaderNode from './types/ethos-graphql-reader';
import EthosReaderNode from './types/ethos-reader';
import EthosV2AsyncReaderNode from './types/ethos-v2-async-reader';
import EthosV2ReaderNode from './types/ethos-v2-reader';
import EthosWriterNode from './types/ethos-writer';

export const ethosNodes = {
  ethosReader: EthosReaderNode,
  ethosWriter: EthosWriterNode,
  ethosV2AsyncReader: EthosV2AsyncReaderNode,
  ethosV2Reader: EthosV2ReaderNode,
  ethosGraphQLReader: EthosGraphQLReaderNode,
};
